module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tm-ac4fe967976efe9a17119dbaa0061a6b.svg";